export const imageContainer = "i10fo0yc";
export const image = "i15idtpj";

require("./style.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");